<template>
    <div>
        <myHead/>
         <a-spin :spinning="isLoading" :tip="spinText">
        <div style="margin-top:20px;padding-left:20px;padding-right:20px;padding-bottom:20px">
            <a-row :gutter="20">
                <a-col :span="24">
                    <div>
                        <span class="title"> 选择任务店铺</span>
                        <div style="padding:20px">
                            <div @click="changeShop(v)" :class="task.ShopId==v.Id?'shop-active':'shop-sel'" v-for="(v,i) in shopList" :key="i">
                                <svg style="vertical-align:middle"  width="25" height="25" v-if="v.Type==1" t="1624775837237"  class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9375"><path d="M376.3 296.6c29.1-49.5 39.8-99 39.8-99l84.2 34-24.5 48s6.1 6.2 27.5 3.1 162.2-74.3 258.6-57.2c97.7 17.3 157.6 94.4 157.6 154.7v289.3s-10.7 88.2-85.7 119.1c-75 30.9-189.7 7.7-189.7 7.7l6.1-48s68.9 15.5 111.7 1.5c42.8-13.9 55.1-48 55.1-48v-345s-6.1-35.6-45.9-60.3c-39.8-24.8-59.7-21.7-102.5-15.5-42.8 6.2-108.6 37.1-108.6 37.1l-36.7 72.7h247.9v49.5H619.6v61.9h157.6v43.3l-154.5 6.2v117.6l73.5-32.5-6.1-51.1 59.7-12.4 44.4 117.6-73.5 34-9.2-41.8s-138.9 59.2-194.6 63.8c-55.7 4.6-110.4-8.8-137-46.9-26.5-38.1-20.3-114.4-20.3-114.4l99 2.5s-7.7 43.5 11.8 71S534 680 534 680V548.8l-153-4.6v-41.8h154.5l-1.5-61.9-47.4-9.3s-39.8 61.9-65.8 60.3c-26-1.5-29.1-37.1-29.1-37.1l84.2-105.2-45.9-4.6-68.9 82-52-46.4c-0.1-0.1 38.2-34.1 67.2-83.6z m-175.9 64.9l-52 74.3s111.7 55.7 120.9 100.6c9.2 44.9-153 179.5-153 179.5l115.7 85s119.8-212 110.7-281.6-142.3-157.8-142.3-157.8z m62.3-31.5c37.8 0 68.4-31 68.4-69.1 0-38.2-30.6-69.1-68.4-69.1-37.8 0-68.4 31-68.4 69.1 0 38.2 30.6 69.1 68.4 69.1z" fill="#d81e06" p-id="9376"></path></svg>
                                <svg style="vertical-align:middle"  width="25" height="25" v-else-if="v.Type==2" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8657"><path d="M178.9 377.2c1.6 21.1 4 42.4 4.8 63.6 1.5 39.5-14.1 70.9-46.2 93.9-24.7 17.7-51.8 30.6-81.4 37.6-34.6 8.1-63.4-20.3-54.4-54.7C6.8 498 13.4 478 23.6 460.7c25.4-42.8 41-89.2 53.7-136.8 2.3-8.9 5.5-17.7 9.5-26 6.9-14.4 22.6-21.8 37.7-17.3 10.9 3.3 21.5 7.9 31.6 13.3 16.1 8.4 31.8 18 47.6 27.1 9.7-10.4 19-21.4 29.1-31.4 35.4-35.1 79-57.4 123.5-78 69.7-32.2 141.4-59.5 216.8-75.2 34.9-7.2 70.6-11.9 106.2-14.6 42.5-3.2 85.2-4.8 127.7-3.7 55.2 1.3 109.6 8.6 160 34 27.2 13.7 50 32.6 54.9 63.6 3.4 21.7 2.1 44.7-0.4 66.8-4.1 37.5-19.4 72-34.3 106.1-4 9-14.4 16.2-23.3 21.5-22.8 13.3-48.2 20.2-74 25.1-72.7 13.9-144.1 7.7-213.6-17.3-41.3-14.8-74.6-41.8-104.9-72.7-3.2-3.2-5.7-7.5-9.6-9.3-4.1-2-10.6-3.6-13.5-1.6-3 2.1-4.8 9-4 13.1 1.1 4.9 4.8 9.8 8.4 13.7 44 47.6 97.6 79.5 160.7 94.1 75.4 17.4 150.5 16.5 224.5-8.1 4.2-1.4 8.4-3 12.5-4.9 4-1.8 7.9-4 13.4-4.9-8.2 11.9-15.9 24-24.4 35.6-57.4 77-131.1 131.2-224 158.3-59.3 17.3-118.6 14.8-177.6 0.5-98.5-24-189-65.4-267-131.4-24.3-20.5-47.2-42.7-63.2-70.6-6.2-10.7-11.4-22.4-14.4-34.2-2.3-9.7-6.2-15.8-14.3-18.3z m717.2-235.3c-11.4 1.1-23 1.5-34.3 3.3-17.5 2.8-34.2 8.5-48.1 20-12.3 10-10.9 24.5 2.8 32.2 5.5 3 11.7 5.3 17.7 6.9 27.7 7.6 55.9 5.6 83.9 2.5 14.4-1.6 28.6-6.2 42.1-11.4 9.3-3.6 16.3-11.6 15.9-23-0.5-10.9-9.3-14.8-17.3-18.6-19.7-9.2-41-11.8-62.7-11.9zM567.3 269.7c16.6 0 29.5-11.7 29.5-26.4-0.1-14.6-13.7-26.7-29.7-26.6-16.7 0.1-29.2 11.6-29.3 26.6 0 14.7 12.9 26.3 29.5 26.4z m128.5 635.9c-7.7 0-15.1 0.5-22.3-0.2-2-0.2-4.7-3.6-5.3-6.1-5.4-21-9.9-42.4-15.8-63.3-2.2-8.2-6.4-16.1-11.2-23.2-7.2-10.9-19.4-12.3-27.5-2.1-7.9 9.8-14.9 20.9-19.8 32.6-7.1 17-12.3 34.9-17.3 52.8-2.1 7.4-4.7 11.2-12.8 9.9-4.6-0.7-9.5-0.1-15.2-0.1 1.2-30.6 2.2-60.2 3.4-92.6-7.2 3.6-12.7 5.4-16.9 8.6-9.7 7.8-19.3 15.9-28 24.7-15.9 16.2-31.3 33-46.7 49.8-9.7 10.5-13.1 11.6-29.8 7.7 19.7-33.5 39.3-66.7 59.5-100.6-19.4-5.6-36.3-13.3-43.5-33.2-4.6-12.4-3.9-24.6 1.2-37.4 1.2 4.3 2.1 8.8 3.4 13.1 6.5 22.3 26.1 33.9 48.2 27.2 5.7-1.8 12-6.5 15.2-11.6 19.4-31.3 38.1-63 56.5-94.8 3.4-5.8 6.8-6.9 13.1-5.8 30.4 4.8 60.8 9.3 91.4 1.3 6.7-1.8 13.1-4.6 20.2-7.1v250.4z" p-id="8658" fill="#d81e06"></path></svg>
                                <svg style="vertical-align:middle"  width="25" height="25" v-else-if="v.Type==3" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8132"><path d="M204.8 81.2c10.3-9 21.4-17 33.2-24.1v343.3c-51.2-36.1-99.3-75.3-150.5-111.5-30.1-21.1-57.2-42.1-87.3-63.2C69.4 177.6 135.8 129.3 205 81.2h-0.2z m-69.2 81.3c0 9.1-3.1 15.1-3.1 24.1-3.1 9.1 9.1 21.1 0 30.1-6 15.1-12 27.1-18 39.2-3.3 4.5-3.3 10.6 0 15.1 3.1 6 12 3.1 18 3.1 6 3.1 9.1 6 15.1 6s9.1-3.1 15.1-3.1 12 3.1 15.1 0c3.1 0 6-3.1 12-6h15c6-3.1 6-12 3.1-18-9.7-9.7-17.8-20.9-24.1-33.2-9.1-12 6-27.1 0-39.2-3.1-3.1-3.1-12-3.1-18h-6c-2.5 7.8-7.9 14.3-15.1 18-7.8-2.5-14.3-7.9-18-15.1 0-3.1-3.1-3.1-6-3.1v0.1zM256 57.2c30.1 21.1 60.3 42.1 93.3 63.2l153.6 108.4c-5.6 3.2-10.7 7.3-15.1 12-75.3 51.2-150.5 105.5-228.9 156.7C256 286 256 171.6 256 57.2z m24.1 129.5c3.3 7.4 7.4 14.5 12 21.1 3.1 0 6-3.1 9.1-3.1V277c27 3 54.3 3 81.3 0 1.5-24.1 1.5-48.2 0-72.3 3.1 0 6 3.1 9.1 3.1 6.7-6.8 11.9-15 15.1-24.1-15.1-3.1-30.1-12-45.2-15.1-3.2 9-11.6 15-21.1 15.1-9.1 0-15.1-9.1-18-15.1-14.8 4.2-28.9 10.2-42.1 18l-0.2 0.1zM521 231.9c81.4-60.3 165.8-117.5 247-174.7v340.4C686.7 343.2 602.4 286 521.1 231.9h-0.1z m132.4-69.3c-4.5 14.7-4.5 30.5 0 45.2 6 15.1 21.1 24.1 30.1 36.1 6 6 3.1 15.1 3.1 21.1-8.6 2.8-16.7 6.8-24.1 12h54.3c-9.1-3.1-15.1-9.1-24.1-12 0-6-3.1-18 3.1-21.1 13.1-9.1 23.5-21.6 30.1-36.1 6-15.1 0-30.1-3.1-45.2h-69.4zM783.1 57.2l63.2 45.2c51.2 36.1 99.3 69.2 150.5 105.5l27.1 18C942.6 283.1 864.3 340.3 783 400.6V57.2z m45.2 93.3c2.6 11.1 10.5 20.1 21.1 24.1h18c-3.1-6-3.1-15.1-9.1-18-9-9.2-21.1-6.1-30-6.1z m48.1 9.1c-3.7 4.6-6.7 9.7-9.1 15.1 6 0 15.1 0 18-3.1 3.7-4.6 6.8-9.7 9.1-15.1-6.1-0.5-12.3 0.6-18 3.1z m-18 21.1c-27.9 4.5-46.9 30.8-42.4 58.7 0.1 0.5 0.2 1.1 0.3 1.6 4.1 26.1 27.8 44.5 54.1 42.1 13.8-1.6 26.5-8 36.1-18 11.9-15.4 15.3-35.8 9.1-54.3-11-21-33.8-33-57.2-30.1z m-66.3 234.9c78.3-57.2 153.6-111.5 231.9-168.7v340.4C945.7 530 870.4 475.7 792.1 418.5c0 0-3.1-3.1 0-3.1v0.2z m123.5-33.2c-19.8 2.5-36.8 15.1-45.2 33.2-3.1 12 9.1 18 15.1 27.1 9.4 8 20.9 13.2 33.2 15.1 8.6 6.7 17.6 12.7 27.1 18 2.5-7.8 3.5-15.9 3.1-24.1 10.5-6.3 20.6-13.4 30.1-21.1 9.1 3.1 15.1 12 21.1 15.1 3.1 0 9.1 0 9.1-3.1-0.6-7.4-2.6-14.5-6-21.1 3.8-6.4 5.8-13.7 6-21.1 0-6-6-9.1-12-6-6.4 3.4-11.7 8.7-15.1 15.1-12-6-21.1-15.1-33.2-21.1v-24.1c-15.1 0-24.1 12-33.2 18l-0.1 0.1zM0 249.9c78.3 57.2 153.6 111.5 231.9 168.7 3.1 0 0 3.1 0 3.1C153.6 475.8 78.3 533.1 0 587.2V249.9z m69.2 117.5c-2.3 5.4-5.4 10.5-9.1 15.1-2.9 3.7-7.3 5.9-12 6-8.1 6.6-12.6 16.6-12 27-3 9.8-3 20.3 0 30.1 0.9 9.1 8.9 15.8 18 15.1h69.2c5.6-0.1 11-2.2 15.1-6 6-6 3.1-18 3.1-27.1-1.2-12.4-4.3-24.6-9.1-36.1-6.2-3.7-12.3-7.7-18-12-2.8-10.3-10.8-18.4-21.1-21.1-8.8 0.2-17.2 3.4-24.1 9z m349.4-21.1c12-15.1 15.1-33.2 24.1-48.1 8.3 14.5 15.3 29.6 21.1 45.2 6 0 12 3.1 21.1 3.1v17.9c9.1-3.1 18-3.1 30.1-6-6-21.1-15.1-42.1-21.1-60.3 21.1 9.1 39.2 15.1 57.2 24.1-6 12-9.1 27.1-15.1 42.1 9.1-3.1 18-3.1 24.1-6 3.1 0 3.1-3.1 6-6 8.3-17.6 15.4-35.7 21.1-54.3 15.1 9.1 27.1 21.1 42.1 30.1l-9.1 9.1c-9.1 9.1-21.1 15.1-30.1 24.1h39.2c3.1 9.1 6 21.1 9.1 30.1h-23.9c-3.1 12-6 24.1-9.1 39.2 11.4 1.6 22.5 4.7 33.2 9.1 5.8 9.2 9.9 19.4 12 30.1-12 3.1-27.1 3.1-39.2 6l-9.1 63.2c-6.3 6-13.4 11.1-21.1 15.1-6-27.1-9.1-54.3-15.1-81.3-9.2 0.5-18.3-0.6-27.1-3.1-6 21.1-9.1 45.2-15.1 66.3-6 9.1-15.1 9.1-24.1 15.1 0.5-26.1-0.5-52.3-3.1-78.3-6.2 0.4-12.4-0.6-18-3.1-3.1-9.1-6-15.1-9.1-24.1-12 12-9.1 30.1-12 45.2-3.1 21.1-6 42.1-9.1 60.3-16.8-11.1-32.8-23.1-48.1-36.1 9.1-3.1 21.1-6 30.1-9.1-3.1-15.1-3.1-30.1-6-45.2-6 3.1-12 9.1-18 12-6-15.1-9.1-33.2-15.1-48.1 11.3-0.3 22.5-2.3 33.2-6 0-12-3.1-21.1-3.1-33.2-3.1 0-6-3.1-9.1-3.1-6.7-9.6-12.7-19.7-18-30.1 8.4-0.2 16.6-2.3 24.1-6l0.1 0.1z m39.1 75.3h30.1l-9.1 18 27.1-9.1c-3.1-9.1-3.1-21.1-6-30.1-6-3.1-12-3.1-18-6-6-6-6-12-9.1-18-12 9.1-12 27.1-15.1 45.2h0.1z m87.3-24.1c-3.1 12-3.1 24.1-6 36.1 12-3.1 21.1-3.1 33.2-6 0-12-3.1-24.1-3.1-33.2-8.2-0.4-16.3 0.6-24.1 3.1zM84.2 367.4c9.1-3.1 18 6 21.1 15.1H69.2c6-6 9.1-12 15.1-15.1h-0.1z m448.9 240.9L768 436.7V780l-72.3-54.3c-54.3-39.2-108.4-81.3-162.7-117.5l0.1 0.1z m141.6-69.2c-3.1 6-3.1 15.1-6 21.1 6-3.1 12-3.1 18-6 10.4-2.4 21.4-0.2 30.1 6-3.1-6-3.1-15.1-6-21.1h-36.1z m6 27.1c-12.2 3.6-22.1 12.4-27.1 24.1-4.8 17.4 2.6 35.9 18 45.2 14.7 8.6 33.3 6.1 45.2-6 15.1-12.7 17.1-35.2 4.4-50.3-3.6-4.4-8.3-7.8-13.5-10-9.1-6-18-3.1-27.1-3.1l0.1 0.1z m-12 78.3c3.1 6 3.1 15.1 6 21.1h33.2c2.4-6.9 4.4-14 6-21.1-12.1 9.1-30.1 6.1-45.2 0z m114.4-210.8c81.3 57.1 159.6 111.4 240.9 168.6l-126.5 90.4C861.4 719.8 822.2 747 786 774c-3-111.5-3-226-3-340.4l0.1 0.1z m78.3 96.4v24.1h9c3.1-6 0-9.1 0-15.1 6-9.1-6-6-9.1-9.1l0.1 0.1z m-33.1 3.1v21.1c3.1 0 6 3.1 9.1 3.1-3.1-9.1 6-24.1-9.1-24.1v-0.1z m69.2 0c-3.1 6 0 12 0 18 0 3.1 9.1 3.1 9.1 0 3.1-6 0-12 0-18h-9.1z m-78.3 32.9v87.3c0 3.1 6 6 9.1 6h69.2c6 0 12 3.1 15.1-3.1 2.5-5.7 3.5-11.9 3.1-18 6-3.1 9.1-3.1 15.1-6 9.5-6.9 12.1-20 6-30.1-6-7.7-14.5-13.1-24.1-15.1v-21h-93.5zM0 602.3C78.3 548 156.7 490.8 238 436.7V777c-48.1-33.2-93.3-69.2-141.6-105.5-33.2-24-66.3-45.1-96.4-69.2z m198.8-57.2c-6 9.1-15.1 15.1-18 24.1-9.1 15.1-12 33.2-24.1 48.1-18 6-42.1 6-57.2 24.1 17.6 12.2 39.9 15.5 60.3 9.1 12-3.1 15.1-15.1 18-24.1 1.3-11.5 6.6-22.2 15.1-30.1 3.1-3.1 6 3.1 6 6v51.2h5.9c0-18-3.1-39.2 6-57.2 5.1-9.1 7.2-19.7 6-30.1-3.4-8.9-9.8-16.3-18-21.1zM256 436.7c48.1 33.2 93.3 66.3 138.5 102.4 30.1 24.1 63.2 45.2 93.3 69.2C409.6 665.5 331.3 722.8 256 780V436.7z m66.3 111.5c-6 3.1-6 9.1-12 12-8.1-0.5-16.3 0.6-24.1 3.1-3.1 0-6 6-6 9.1v69.2c0 6 9.1 6 12 6h99.3c6 0 6-6 6-12v-69.5c-8.2-4.8-17.7-6.9-27.1-6-3.6-5.6-8.9-9.8-15.1-12l-33 0.1zM265.1 792c81.3-57.2 159.6-114.4 240.9-168.7V804c3.1 54.3 0 108.4 0 159.6-57.2-39.2-111.5-81.3-168.7-120.4-24.1-18-51.2-36.1-72.3-51.2h0.1z m150.5-66.3h12c-3.1-3.1-3.1-6-6-6l-6 6z m-42.1 27.1c-7.8 11.1-13.9 23.2-18 36.1 3.1 0 9.1-3.1 12-3.1 9.1 0 18 3.1 24.1 0 6.7-3 14.4-3 21.1 0 0.5 16.2-0.5 32.4-3.1 48.4 0 6-9.1 6-12 6l-9.1-18c-3.1 3.1-6 3.1-6 6-1.3 10.6 5 20.6 15.1 24.1 11.3 3.5 23.4-2.9 26.9-14.2l0.3-0.9V786c9.1-2 18.7-0.9 27.1 3.1 10.8-3 22.3-3 33.2 0-1.9-12.2-7.1-23.7-15.1-33.2-5.7-6.7-13-11.9-21.1-15.1-24.2-17.5-57.9-12.1-75.4 12z m147.6-129.4c81.3 57.2 159.6 111.5 240.9 168.7-78.3 57.2-159.6 117.5-238 174.7-3-117.5-3-231.9-3-343.2l0.1-0.2z m78.3 96.4c-3.1 3.1-3.1 9.1-9.1 9.1-9.1 6-18 15.1-27.1 21.1 3.5 2.4 7.8 3.5 12 3.1h66.3c-6-9.1-15.1-12-21.1-18-9.1-6-15.1-12-21.1-15.1l0.1-0.2z m-36.2 45.1v63.2c0 3.1 0 9.1 6 9.1h69.2c2.5-8.8 3.5-18 3.1-27.1v-45.2c0-3.1-6-3.1-9.1-3.1-23.1-0.6-46.2 0.4-69.2 3.1z" p-id="8133" fill="#d81e06"></path></svg>
                                <svg style="vertical-align:middle"  width="25" height="25" v-else-if="v.Type==5" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7433" ><path d="M602.9 669.8c-37.2 2.6-33.6-17.3-11.5-46.2 50.4-67.2 143.7-158.5 147.9-225.2 5.8-86.6-81.3-113.4-171-113.4-62.4 1.6-127 18.9-171 34.6-151.6 53.5-246.6 137.5-306.9 232-62.4 93.4-43 183.2 91.8 185.8 101.8-4.2 170.5-32.5 239.7-68.2 0.5 0-192.5 55.1-263.9 14.7-7.9-4.2-15.7-10-17.8-26.2 0-33.1 54.6-67.7 86.6-78.7v-56.7c64.5 22.6 140.6 16.3 205.7-32 2.1 5.8 4.2 13.1 3.7 21h11c2.6-22.6-12.6-44.6-37.8-46.2 7.3 5.8 12.6 10.5 15.2 14.7l-1 1-0.5 0.5c-83.9 58.8-165.3 31.5-173.1 29.9l46.7-45.7-13.1-33.1c92.9-32.5 169.5-56.2 296.9-78.7l-28.5-23 14.7-8.9c75.5 21 126.4 36.7 123.8 76.6-1 6.8-3.7 14.7-7.9 23.1C660.1 466.1 594 538 567.2 569c-17.3 20.5-34.6 39.4-46.7 58.3-13.6 19.4-20.5 37.3-21 53.5 2.6 131.8 391.4-61.9 468-112.9-111.7 47.8-232.9 93.5-364.6 101.9z m85-302.9c2.8 5.2 4.1 11.6 4.1 19.1-0.1-6.8-1.4-13.3-4.1-19.1z" p-id="7434" fill="#d81e06"></path></svg>
                                <svg style="vertical-align:middle"  width="25" height="25" v-else class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1814" ><path d="M937.4 423.9c-84 0-165.7-27.3-232.9-77.8v352.3c0 179.9-138.6 325.6-309.6 325.6S85.3 878.3 85.3 698.4c0-179.9 138.6-325.6 309.6-325.6 17.1 0 33.7 1.5 49.9 4.3v186.6c-15.5-6.1-32-9.2-48.6-9.2-76.3 0-138.2 65-138.2 145.3 0 80.2 61.9 145.3 138.2 145.3 76.2 0 138.1-65.1 138.1-145.3V0H707c0 134.5 103.7 243.5 231.6 243.5v180.3l-1.2 0.1" p-id="1815" fill="#d81e06"></path></svg>
                                {{v.Name}}
                            </div>
                        </div>
                    </div>
                </a-col>
            </a-row>

            <a-row :gutter="20" style="margin-top:-20px">
                <a-col :span="24">
                    <div>
                        <span class="title"> 任务要求设置</span>
                        <div style="padding:20px">
                            <a-descriptions  bordered>
                                <a-descriptions-item label="期望完成日期">    
                                    <a-date-picker 	format="YYYY-MM-DD" placeholder="请选择任务日期" v-model:value="datePickerValue" />
                                </a-descriptions-item>
                                <a-descriptions-item label="任务开始时间">
                                    <a-input-number  v-model:value="task.StartHour" :min="8" :max="22" />
                                </a-descriptions-item>
                                <a-descriptions-item label="任务结束时间">
                                    <a-input-number  v-model:value="task.EndHour" :min="9" :max="23" />
                                </a-descriptions-item>
                                <a-descriptions-item label="返款方式">
                                    <a-radio-group @change="changeRebateMethod" name="radioGroup" v-model:value="task.RebateMethod">
                                            <a-tooltip placement="bottom">
                                                <template #title>
                                                    <div>* 注意事项 *</div>
                                                    <div>发布任务时扣除本金</div>
                                                    <div>实付与预计不一致时多退少补</div>
                                                </template>
                                                <a-radio :value="0">平台返款</a-radio>
                                            </a-tooltip>
                                             <a-tooltip placement="bottom">
                                                <template #title>
                                                    <div>* 注意事项 *</div>
                                                    <div>自返优惠 0.5 元一单</div>
                                                    <div>跑单由平台赔付</div>
                                                    <div>当日任务当日返款，否则可能退款</div>
                                                    <div>重复返款责任在商家，平台会帮追讨</div>
                                                </template>
                                                <a-radio :value="1">商家自返</a-radio>
                                            </a-tooltip>
                                    </a-radio-group>
                                </a-descriptions-item>
                                <a-descriptions-item label="隔日单">
                                    <a-tooltip placement="bottom">
                                        <template #title>
                                            <div>今日打标，隔日下单</div>
                                        </template>
                                       <a-switch v-model:checked="task.IsNextDay"   />
                                    </a-tooltip>
                                    <span  class="animate__animated animate__fadeInLeft"  style="color:red;margin-left:10px"  v-show="task.IsNextDay" >
                                        + 1.0 元/单                                 
                                    </span>
                                </a-descriptions-item>

                                <a-descriptions-item label="审单方式">
                                    <a-radio-group name="radioGroup"  :disabled="true" v-model:value="task.ReviewMethod">
                                            <a-tooltip placement="bottom">
                                                <template #title>
                                                    <div>* 注意事项 *</div>
                                                    <div>平台审核任务，不加收任何服务费</div>
                                                    <div>但是我们看不到买手是否使用 红包/花呗/信用卡</div>
                                                </template>
                                                <a-radio :value="0">平台审单</a-radio>
                                            </a-tooltip>
                                             <a-tooltip placement="bottom">
                                                <template #title>
                                                    <div>* 注意事项 *</div>
                                                    <div>即将上线</div>
                                                </template>
                                                <a-radio :value="1">商家自审</a-radio>
                                            </a-tooltip>
                                    </a-radio-group>
                                </a-descriptions-item>
                                
                                <a-descriptions-item label="进店方式" >
                                    <a-select style="width:112px"
                                            v-model:value="task.KeyType" @change="changeKeyType">
                                        <a-select-option :value="0">关键字</a-select-option>
                                        <a-select-option :value="1">口令</a-select-option>
                                        <a-select-option :value="2">扫码</a-select-option>
                                    </a-select>
                                </a-descriptions-item>
                               
                                
                                <a-descriptions-item label="买号年龄要求">
                                    <a-select style="width:112px"
                                            v-model:value="task.SwipeAge" >
                                        <a-select-option :value="0">不限</a-select-option>
                                        <a-select-option :value="1">22岁以下</a-select-option>
                                        <a-select-option :value="2">23岁-28岁</a-select-option>
                                        <a-select-option :value="3">29岁-35岁</a-select-option>
                                        <a-select-option :value="4">36岁-45岁</a-select-option>
                                        <a-select-option :value="5">46岁以上</a-select-option>
                                    </a-select>
                                    <span class="animate__animated animate__fadeInLeft" v-show="task.SwipeAge>0" style="color:red;margin-left:20px"> + 0.3 元/单</span>

                                </a-descriptions-item>

                                <a-descriptions-item label="买号性别要求">
                                    <a-radio-group name="radioGroup" v-model:value="task.SwipeGender">
                                        <a-radio :value="0">不限</a-radio>
                                        <a-radio :value="1">男</a-radio>
                                        <a-radio :value="2">女</a-radio>
                                    </a-radio-group>
                                    <span  class="animate__animated animate__fadeInLeft"  style="color:red"  v-show="task.SwipeGender>0" >
                                         + 0.3 元/单                                        
                                    </span>
                                </a-descriptions-item>

                                 <a-descriptions-item label="淘客订单拦截" >
                                        <a-switch v-model:checked="task.Intercept"  :disabled="type!=1"  />
                                       <span  class="animate__animated animate__fadeInLeft"  style="color:red;margin-left:10px"  v-show="task.Intercept" >
                                            + 0.5 元/单                                        
                                        </span>
                                </a-descriptions-item>

                                <a-descriptions-item label="买号信誉要求" :span="2">
                                    <a-select style="width:112px" :disabled="type!=1"
                                            v-model:value="task.SwipeBuyerGoodNum" >
                                        <a-select-option :value="0">不限</a-select-option>
                                        <a-select-option :value="1">二心以上</a-select-option>
                                        <a-select-option :value="2">三心以上</a-select-option>
                                        <a-select-option :value="3">四心以上</a-select-option>
                                        <a-select-option :value="4">五心以上</a-select-option>
                                        <a-select-option :value="5">一钻以上</a-select-option>
                                    </a-select>
                                    <span class="animate__animated animate__fadeInLeft" v-show="task.SwipeBuyerGoodNum>0" style="color:red;margin-left:20px"> + 0.3 元/单</span>

                                </a-descriptions-item>

                                

                                <a-descriptions-item label="特殊要求" :span="3">

                                    <a-textarea  placeholder="其他需求可以在这里填写告知买手，如付款方式，信用卡花呗等，平台会尽量协调！" v-model:value="task.Remark" :rows="2" showCount :maxlength="100" />
                                </a-descriptions-item>
                             </a-descriptions>
                        </div>
                    </div>
                </a-col>
            </a-row>
            <a-row :gutter="20" style="margin-top:0px">
                <a-col :span="24">
                    <div>
                        <span class="title"> 任务商品数据</span>
                        <div style="padding:20px">
                            <a-button type="primary" @click="addRow(1)" style="margin-bottom:10px">添加一行</a-button>
                            <a-button type="" @click="goodsInfo" style="margin-bottom:10px;margin-left:10px">获取宝贝数据</a-button>
                            <a-button  @click="importExcel" style="margin-bottom:10px;margin-left:10px">导入表格</a-button>
                            
                            <input type="file" ref="uploadExcel" v-show="false" accept=".xls,.xlsx" @change="readExcel">
                            <a @click="xiazai" style="margin-left:10px;color:#ec5e95"><VerticalAlignBottomOutlined /> 导入模板下载</a>
                            
                            <span style="line-height:20px;margin-left:10px;" v-show="task.Details.length>0">
                                 共 <a-badge style="margin-top:-2px" :count="task.Details.length" /> 行
                            </span>
                            <span style="color:#6e6d7a;float:right;margin-right:20px">提示：行内复制操作可以快速复制内容修改~</span>
                            <a-table  :rowKey="index => index.toString()"  :pagination="false" :data-source="task.Details" :columns="columns">
                                <template #keyWordsTitle>
                                    <span v-if="task.KeyType==0">关键字</span>
                                    <span v-else-if="task.KeyType==1">淘口令</span>
                                    <span v-else>二维码</span>
                                </template>

                                <template #img="{ record,index }">
                                    <div>
                                        <a-upload
                                         v-model:file-list="fileList[index]"
                                        :multiple="false"
                                         accept="image/gif,image/jpeg,image/jpg,image/png,image/svg"
                                        :action="baseUrl+'/Task/PushImg'"
                                        list-type="picture-card"
                                        @change="(info) => handleChange(info, record)"
                                        @preview="handlePreview"
                                        >
                                        <div v-if="record.Img==''&&uploading==false">
                                            <PlusOutlined />
                                        </div>
                                        </a-upload>
                                    </div>
                                </template>
                                <template #recordTitle="{ record }">
                                    <div>
                                         <a-textarea showCount :maxlength="150"  v-model:value="record.Title" placeholder="请输入商品标题" :rows="3" />
                                    </div>
                                </template>
                                <template #recordUrl="{ record }">
                                    <div>
                                        <!-- <a-tooltip color="#fff" placement="top">
                                            <template #title>
                                                <a-button @click="getPicture(record)" type="primary">一键抓取商品主图</a-button>
                                            </template> -->
                                        <a-textarea    showCount :maxlength="255" v-model:value="record.Url" placeholder="请输入商品链接" :rows="3" />
                                        <!-- </a-tooltip> -->
                                    </div>
                                </template>
                               <template #recordSpec="{ record }">
                                    <div>
                                         <a-textarea showCount :maxlength="30" v-model:value="record.Spec" placeholder="请输入商品规格，如无可以不填写" :rows="3" />
                                    </div>
                                </template>
                                <template #recordkeyWords="{ record,index }">
                                    <div>
                                         <a-textarea v-if="task.KeyType==0" showCount :maxlength="255"  v-model:value="record.KeyWords" placeholder="请输入搜索关键字" :rows="3" />
                                         <a-textarea v-else-if="task.KeyType==1" showCount :maxlength="255"  v-model:value="record.KeyWords" placeholder="请输入淘口令" :rows="3" />
                                         <a-upload v-else-if="task.KeyType==2"
                                            v-model:file-list="codeFileList[index]"
                                            :multiple="false"
                                            accept="image/gif,image/jpeg,image/jpg,image/png,image/svg"
                                            :action="baseUrl+'/Task/PushImg'"
                                            list-type="picture-card"
                                            @change="(info) => keyWordChange(info, record)"
                                            @preview="handlePreview"
                                            >
                                            <div v-if="record.KeyWords==''&&uploading==false">
                                                <PlusOutlined />
                                            </div>
                                        </a-upload>
                                    </div>
                                </template>
                                <template #showPrice="{ record }">
                                    <div>
                                        <a-input-number
                                        :min="0"
                                        style="width:100px"
                                        v-model:value="record.ShowPrice"
                                        :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                        :parser="value => value.replace(/\￥\s?|(,*)/g, '')"/>
                                    </div>
                                </template>
                                <template #price="{ record }">
                                    <div>
                                        <a-input-number
                                        :min="0"
                                        style="width:100px"
                                        v-model:value="record.Price"
                                        :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                        :parser="value => value.replace(/\￥\s?|(,*)/g, '')"/>
                                    </div>
                                </template>
                                <template #buyNum="{ record }">
                                    <div>
                                        <a-input-number
                                        :min="1"
                                        style="width:50px"
                                        v-model:value="record.BuyNum"/>
                                    </div>
                                </template>
                                <template #num="{ record }">
                                    <div>
                                        <a-input-number
                                        :min="1"
                                        style="width:50px"
                                        v-model:value="record.Num"/>
                                    </div>
                                </template>
                                <template #buyRemark="{ text }">
                                        {{text}}
                                </template>
                                <template #child="{record}">
                                    <a-tag @click="showChild(record)" class="prase-btn" color="#f082ac">
                                        {{record.ChildList.length}}
                                    </a-tag>
                                </template>
                                <template #praise="{  record }">
                                     <a-tag class="prase-btn"  @click="setPraise(record)" v-if="record.Video" color="#409EFF">
                                         <EditOutlined /> 视频好评</a-tag>
                                     <a-tag class="prase-btn"  @click="setPraise(record)" v-else-if="record.ZiyuanImg.length>0" color="#409EFF">
                                         <EditOutlined /> 图片好评</a-tag>
                                     <a-tag class="prase-btn"  @click="setPraise(record)" v-else-if="record.PositiveContent" color="#409EFF">
                                         <EditOutlined /> 文字好评</a-tag>
                                    <a-tag class="prase-btn" @click="setPraise(record)" v-else color="#409EFF">
                                        <EditOutlined /> 默认好评</a-tag>
                                </template>
                                <template #action="{  index }">
                                    <a-tooltip placement="bottom">
                                        <template #title>
                                            <div>删除这一行</div>
                                        </template>
                                        <a @click="remove(index)"><DeleteOutlined /></a>
                                    </a-tooltip>
                                    <a-divider type="vertical" />
                                   
                                    <a-tooltip placement="bottom">
                                        <template #title>
                                            <div>复制这一行</div>
                                            <div>好评内容不会被复制</div>
                                        </template>
                                         <a @click="copyRow(index)"><CopyOutlined /> </a>
                                    </a-tooltip>
                                    <a-divider type="vertical" />
                                </template>
                            </a-table>
                        </div>
                    </div>
                </a-col>
            </a-row>
            <a-row :gutter="20" style="margin-top:20px;margin-bottom:20px">
                <a-col :span="24">
                     <a-button :loading="paying" style="width:250px;float:right;margin-right:10%" @click="goPay"  class="my-btn">
                        <span>
                            去支付
                        </span>
                    </a-button>
                </a-col>
            </a-row>
        </div>
        </a-spin>
        <myFooter/>
        <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible=false">
            <img alt="example" style="width: 100%" :src="previewImage" />
        </a-modal>


            <a-drawer
    title="子链接"
    width="80%"
    :visible="childVisible"
    :body-style="{ paddingBottom: '80px' }"
    @close="childVisible=false"
  >
                        <a-button type="primary" @click="addChildRow(1)" style="margin-bottom:10px">添加</a-button>
                        <a-table  :rowKey="index => index.toString()"  :pagination="false" :data-source="setRow.ChildList" :columns="childColumns">
                                <template #img="{ record }">
                                    <div>
                                        <!-- v-model:file-list="setRow.ChildList[index]" -->
                                        <a-upload
                                        :multiple="false"
                                         accept="image/gif,image/jpeg,image/jpg,image/png,image/svg"
                                        :action="baseUrl+'/Task/PushImg'"
                                        list-type="picture-card"
                                        @change="(info) => handleChange(info, record)"
                                        @preview="handlePreview"
                                        >
                                        <div v-if="record.Img==''&&uploading==false">
                                            <PlusOutlined />
                                        </div>
                                        </a-upload>
                                    </div>
                                </template>
                                <template #recordTitle="{ record }">
                                    <div>
                                         <a-textarea showCount :maxlength="150"  v-model:value="record.Title" placeholder="请输入商品标题" :rows="3" />
                                    </div>
                                </template>
                                <template #recordUrl="{ record }">
                                    <div>
                                        <a-textarea    showCount :maxlength="255" v-model:value="record.Url" placeholder="请输入商品链接" :rows="3" />
                                    </div>
                                </template>
                               <template #recordSpec="{ record }">
                                    <div>
                                         <a-textarea showCount :maxlength="30" v-model:value="record.Spec" placeholder="请输入商品规格，如无可以不填写" :rows="3" />
                                    </div>
                                </template>
                                <template #showPrice="{ record }">
                                    <div>
                                        <a-input-number
                                        :min="0"
                                        style="width:100px"
                                        v-model:value="record.ShowPrice"
                                        :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                        :parser="value => value.replace(/\￥\s?|(,*)/g, '')"/>
                                    </div>
                                </template>
                                <template #price="{ record }">
                                    <div>
                                        <a-input-number
                                        :min="0"
                                        style="width:100px"
                                        v-model:value="record.Price"
                                        :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                        :parser="value => value.replace(/\￥\s?|(,*)/g, '')"/>
                                    </div>
                                </template>
                                <template #buyNum="{ record }">
                                    <div>
                                        <a-input-number
                                        :min="1"
                                        style="width:50px"
                                        v-model:value="record.BuyNum"/>
                                    </div>
                                </template>
                                <template #praise="{  record }">
                                     <a-tag class="prase-btn"  @click="setChildPraise(record)" v-if="record.Video" color="#409EFF">
                                         <EditOutlined /> 视频好评</a-tag>
                                     <a-tag class="prase-btn"  @click="setChildPraise(record)" v-else-if="record.ZiyuanImg.length>0" color="#409EFF">
                                         <EditOutlined /> 图片好评</a-tag>
                                     <a-tag class="prase-btn"  @click="setChildPraise(record)" v-else-if="record.PositiveContent" color="#409EFF">
                                         <EditOutlined /> 文字好评</a-tag>
                                    <a-tag class="prase-btn" @click="setChildPraise(record)" v-else color="#409EFF">
                                        <EditOutlined /> 默认好评</a-tag>
                                </template>
                                <template #action="{  index }">
                                    <a-tooltip placement="bottom">
                                        <template #title>
                                            <div>删除这一行</div>
                                        </template>
                                        <a @click="removeChild(index)"><DeleteOutlined /></a>
                                    </a-tooltip>
                                </template>
                            </a-table>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }">

      <a-button type="primary" @click="childVisible=false">确定</a-button>
    </div>
  </a-drawer>


    <a-drawer
    title="设置好评"
    :width="800"
    :visible="praiseVisible"
    :body-style="{ paddingBottom: '80px' }"
    @close="praiseVisible=false"
  >
    <a-form :model="setRow"     layout="vertical">
        <a-row :gutter="16">
            <a-col :span="24">
                <a-form-item label="好评文字">
                     <a-textarea v-model:value="setRow.PositiveContent" placeholder="请输入好评内容" showCount />
                </a-form-item>
            </a-col>
        </a-row>
        <a-row :gutter="16" style="height:148px">
            <a-col :span="24">
                <a-form-item label="好评图片">
                    <a-upload
                     accept="image/gif,image/jpeg,image/jpg,image/png,image/svg"
                    :multiple="true"
                    :action="baseUrl+'/Task/PushImg'"
                    list-type="picture-card"
                    v-model:file-list="setRow.ZiyuanImg"
                    @preview="handlePreview"
                    >
                    <div>
                        <PlusOutlined />
                    </div>
                    </a-upload>
                </a-form-item>
            </a-col>
        </a-row>
        <a-row :gutter="16">
            <a-col :span="24">
                <a-form-item label="好评视频">
                        <a-upload
                             name="file"
                            accept=".mp4"
                            :multiple="false"
                            :action="baseUrl+'/Task/PushVideo'"
                            @change="videoChange"
                         >
                            <a-button v-if="!setRow.Video&&!uploading">
                               点击上传
                            </a-button>
                        </a-upload>
                         <video id="video1" style="width:100%;height:240px;margin-top:15px" :src="setRow.Video" controls>
                            您的浏览器不支持 video 标签。
                        </video>
                </a-form-item>
            </a-col>
        </a-row>

        <a-row>
            <a-form-item style="margin:auto">
                <a-alert
                    message="费用说明"
                    description="纯文字好评 2元/单、带图片 3元/单、带视频 5元/单，评价完成之后，系统将自动从余额扣除！"
                    type="info"
                    show-icon/>
            </a-form-item>
        </a-row>
    </a-form>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }">

      <a-button type="primary" @click="praiseVisible=false">确定</a-button>
    </div>
  </a-drawer>


   <a-drawer
    title="设置好评"
    :width="800"
    :visible="childPraiseVisible"
    :body-style="{ paddingBottom: '80px' }"
    @close="childPraiseVisible=false"
  >
    <a-form :model="childRow"     layout="vertical">
        <a-row :gutter="16">
            <a-col :span="24">
                <a-form-item label="好评文字">
                     <a-textarea v-model:value="childRow.PositiveContent" placeholder="请输入好评内容" showCount :maxlength="250" />
                </a-form-item>
            </a-col>
        </a-row>
        <a-row :gutter="16" style="height:148px">
            <a-col :span="24">
                <a-form-item label="好评图片">
                    <a-upload
                     accept="image/gif,image/jpeg,image/jpg,image/png,image/svg"
                    :multiple="true"
                    :action="baseUrl+'/Task/PushImg'"
                    list-type="picture-card"
                    v-model:file-list="childRow.ZiyuanImg"
                    @preview="handlePreview"
                    >
                    <div v-if="childRow.ZiyuanImg.length < 5">
                        <PlusOutlined />
                    </div>
                    </a-upload>
                </a-form-item>
            </a-col>
        </a-row>
        <a-row :gutter="16">
            <a-col :span="24">
                <a-form-item label="好评视频">
                        <a-upload
                            name="file"
                            accept=".mp4"
                            :multiple="false"
                            :action="baseUrl+'/Task/PushVideo'"
                            @change="childVideoChange"
                         >
                            <a-button v-if="!childRow.Video&&!uploading">
                               点击上传
                            </a-button>
                        </a-upload>
                         <video id="video1" style="width:100%;height:240px;margin-top:15px" :src="childRow.Video" controls>
                            您的浏览器不支持 video 标签。
                        </video>
                </a-form-item>
            </a-col>
        </a-row>

        <a-row>
            <a-form-item style="margin:auto">
                <a-alert
                    message="费用说明"
                    description="纯文字好评 2元/单、带图片 3元/单、带视频 5元/单，评价完成之后，系统将自动从余额扣除！"
                    type="info"
                    show-icon/>
            </a-form-item>
        </a-row>
    </a-form>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }">

      <a-button type="primary" @click="childPraiseVisible=false">确定</a-button>
    </div>
  </a-drawer>



    </div>
</template>
<script>
import myHead from '../components/myHead'
import myFooter from '../components/myFooter'
import { message } from 'ant-design-vue';
import XLSX from 'xlsx'
import { DeleteOutlined,PlusOutlined,EditOutlined,CopyOutlined,VerticalAlignBottomOutlined} from '@ant-design/icons-vue';

import { shopGetSel,uri,toolGetPicture,taskCopyTask,taskPreCreate,taskExistDetail,taskGetGoodsInfo} from '@/request.js'

export default {
    components:{myHead,myFooter,DeleteOutlined,PlusOutlined,EditOutlined,CopyOutlined,VerticalAlignBottomOutlined},
    data() {
        return {
            childPraiseVisible:false,
            childVisible:false,
            spinText:"加载中...",
            paying:false,
            mubanUrl:'https://hlqimg.oss-cn-heyuan.aliyuncs.com/%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx',
            isLoading:false,
            datePickerValue:undefined,
            fileList:[],
            codeFileList:[],
            uploading:false,
            praiseVisible:false,
            previewImage:"",
            previewVisible:false,
            baseUrl:uri,
            taskType:1,
            shopList:[],
            task:{
                ReviewMethod:0,
                Remark:"",
                SwipeAge:0,
                SwipeGender:0,
                Intercept:false,
                SwipeBuyerGoodNum:0,
                RebateMethod:0,
                StartHour:8,
                EndHour:18,
                ExpectedOverTime:'',
                ShopId:undefined,
                KeyType:0,
                Details:[

                ],
            },
            columns:[
                {
                    title: '主图',
                    dataIndex: 'Img',
                    key: 'Img',
                    width:100,
                    slots: { customRender: 'img' },
                },
                {
                    title: '标题',
                    dataIndex: 'Title',
                    key: 'Title',
                    slots: { customRender: 'recordTitle' },
                },
                {
                    title: '链接',
                    dataIndex: 'Url',
                    key: 'Url',
                    slots: { customRender: 'recordUrl' },
                },
                {
                    title: '规格',
                    dataIndex: 'Spec',
                    key: 'Spec',
                    slots: { customRender: 'recordSpec' },
                },
                {
                    dataIndex: 'keyWords',
                    key: 'keyWords',
                    slots: { customRender: 'recordkeyWords',title: 'keyWordsTitle' },
                },
                {
                    title: '显示价格',
                    dataIndex: 'ShowPrcie',
                    key: 'ShowPrcie',
                    slots: { customRender: 'showPrice' },
                },
                {
                    title: '实际价格',
                    dataIndex: 'Price',
                    key: 'Price',
                    slots: { customRender: 'price' },
                },
                {
                    title: '购买数量',
                    dataIndex: 'BuyNum',
                    key: 'BuyNum',
                    slots: { customRender: 'buyNum' },
                },
                {
                    title: '单数',
                    dataIndex: 'Num',
                    key: 'Num',
                    slots: { customRender: 'num' },
                },
                {
                    title: '好评',
                    key: 'Praise',
                    slots: { customRender: 'praise' },
                },
                {
                    title: '子链接',
                    key: 'Child',
                    slots: { customRender: 'child' },
                },
                {
                    title: '操作',
                    key: 'action',
                    slots: { customRender: 'action' },
                },
            ],
            childColumns:[
                {
                    title: '主图',
                    dataIndex: 'Img',
                    key: 'Img',
                    width:100,
                    slots: { customRender: 'img' },
                },
                {
                    title: '标题',
                    dataIndex: 'Title',
                    key: 'Title',
                    slots: { customRender: 'recordTitle' },
                },
                {
                    title: '链接',
                    dataIndex: 'Url',
                    key: 'Url',
                    slots: { customRender: 'recordUrl' },
                },
                {
                    title: '规格',
                    dataIndex: 'Spec',
                    key: 'Spec',
                    slots: { customRender: 'recordSpec' },
                },
                {
                    title: '显示价格',
                    dataIndex: 'ShowPrcie',
                    key: 'ShowPrcie',
                    slots: { customRender: 'showPrice' },
                },
                {
                    title: '实际价格',
                    dataIndex: 'Price',
                    key: 'Price',
                    slots: { customRender: 'price' },
                },
                {
                    title: '购买数量',
                    dataIndex: 'BuyNum',
                    key: 'BuyNum',
                    slots: { customRender: 'buyNum' },
                },
                {
                    title: '好评',
                    key: 'Praise',
                    slots: { customRender: 'praise' },
                },
                {
                    title: '操作',
                    key: 'action',
                    slots: { customRender: 'action' },
                },
            ],
            setRow:{},
            childRow:{},
            type:0,
        };
    },
    created(){
        
    },
    mounted() {
        this.isLoading=true;
        shopGetSel({},(res)=>{
            this.shopList=res.Result;
            if(this.$route.query.copy){
                taskCopyTask({taskId:this.$route.query.copy},(res)=>{
                    this.task=res.Result;
                    if(this.task.RebateMethod==1){
                        this.task.ReviewMethod=1;
                    }
                    this.task.Details.forEach(x=>{
                        var array=new Array();
                        if(x.Img){
                            array.push({
                                name:x.Img,
                                response:{
                                    IsSuccess:true,
                                    Message:x.Img,
                                },
                                status:"done",
                                thumbUrl:x.Img,
                                type:"image/jpeg",
                                uid:x.Img,
                            });
                        }
                        this.fileList.push(array);
                        var codeArray=new Array();
                        if(this.task.KeyType==2){
                            codeArray.push({
                                name:x.KeyWords,
                                response:{
                                    IsSuccess:true,
                                    Message:x.KeyWords,
                                },
                                status:"done",
                                thumbUrl:x.KeyWords,
                                type:"image/jpeg",
                                uid:x.KeyWords,
                            });
                        }
                        this.codeFileList.push(codeArray);
                    })
                    this.isLoading=false;
                })
            }else{
                this.isLoading=false;
            }
            
        })
    },
    methods:{
        changeRebateMethod(){
            if(this.task.RebateMethod==1){
                this.task.ReviewMethod=1;
            }else{
                this.task.ReviewMethod=0;
            }
        },
        changeShop(v){
            this.task.ShopId=v.Id;
            this.type=v.Type;
            if(this.type==6){
                this.task.KeyType=1;
            }
            if(this.type!=1){
                this.task.Intercept=false;
                this.task.SwipeBuyerGoodNum=0;
            }
        },
        childVideoChange(info){
            if(info.file.status=="uploading"){
                this.uploading=true;
            }
            else if(info.file.status=="removed"){
                this.setRow.Video="";
            }
            else{
                if(info.file.response){
                    var res=info.file.response;
                    if(res.IsSuccess){
                        this.uploading=false;
                        this.childSetRow.Video= res.Message;
                    }else{
                        message.error(res.Message);
                    }
                }
            }
        },
        childHandleChange(info,record){
            if(info.file.status=="uploading"){
                this.uploading=true;
            }
            else if(info.file.status=="removed"){
                record.Img="";                
            }
            else{
                if(info.file.response){
                    var res=info.file.response;
                    if(res.IsSuccess){
                        this.uploading=false;
                        record.Img= res.Message;
                    }else{
                        message.error(res.Message);
                    }
                }
            }
        },
        addChildRow(num){
            if(!this.task.ShopId){
                message.error("请先选择好店铺！");
                return; 
            }
            for(var i=0;i<num;i++){
                let childRow={
                    Title:"",
                    Url:"",
                    ShowPrice:0,
                    Price:0,
                    BuyNum:1,
                    Spec:"",
                    Video:"",
                    ZiyuanImg:[],
                    Img:"",
                    PositiveContent:"",
                }
                this.setRow.ChildList.push(childRow);
            }
        },
        removeChild(index){
            this.setRow.ChildList.splice(index, 1);
        },
        setChildPraise(record){
            this.childRow=record;
            this.childPraiseVisible=true;
        },
        showChild(record){
            this.setRow=record;
            this.childVisible=true;
        },
        zhua(){
            if(this.task.Details.length==0){
                message.error("还没有任何一行商品数据哦");
                return; 
            }
            this.task.Details.forEach(x=>{
                if(!x.Url){
                    message.error("请确保每一行数据都填写了链接");
                    return;
                }
            })
            this.isLoading=true;
            taskExistDetail({json:JSON.stringify(this.task.Details),shopId:this.task.ShopId},(res)=>{
                this.isLoading=false;
                this.task.Details=res.Result;
                this.task.Details.forEach(x=>{
                    var array=new Array();
                    if(x.Img){
                        array.push({
                            name:x.Img,
                            response:{
                                IsSuccess:true,
                                Message:x.Img,
                            },
                            status:"done",
                            thumbUrl:x.Img,
                            type:"image/jpeg",
                            uid:x.Img,
                        });
                    }
                    this.fileList.push(array);
                })
                this.isLoading=false;
            })
        },
        readExcel(e) {
            this.isLoading=true;
            const files = e.target.files;
            if (files.length <= 0) {
                //如果没有文件名
                this.isLoading=false;
                return false;
            }
            const fileReader = new FileReader();
            fileReader.onload = ev => {
            try {
                this.loadingExl=true;
                const data = ev.target.result;
                const workbook = XLSX.read(data, {
                    type: "binary"
                });
                const wsname = workbook.SheetNames[0]; //取第一张表
                const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //获取到XLSX表格中的数据,并生成json格式的数据类型
                let arr = [];
                ws.forEach((value, index, ws) => {
                    if(ws[index]["商品标题"] + ""!=""&&parseFloat(ws[index]["实际价格"])!="undefined"&&!isNaN(parseFloat(ws[index]["实际价格"]))){
                        let item=arr.find(x=>x.MasterId==ws[index]["标识"]);
                        if(ws[index]["标识"]&&item){
                            item.ChildList.push({
                                Title: ws[index]["商品标题"] + "",
                                Url: ws[index]["商品链接"] + "",
                                Spec: ws[index]["购买规格"] + "",
                                Price: parseFloat(ws[index]["实际价格"]),
                                ShowPrice: parseFloat(ws[index]["显示价格"]),
                                BuyNum: parseInt(ws[index]["每单拍几件"]),
                                Img:"",
                                ZiyuanImg:[],
                                Video:"",
                                PositiveContent:"",
                            });
                            console.log(item.ChildList);
                        }
                        else{
                            arr.push({
                                Title: ws[index]["商品标题"] + "",
                                KeyWords: ws[index]["关键词"] + "",
                                Num: parseInt(ws[index]["单数"]),
                                Url: ws[index]["商品链接"] + "",
                                Spec: ws[index]["购买规格"] + "",
                                Price: parseFloat(ws[index]["实际价格"]),
                                ShowPrice: parseFloat(ws[index]["显示价格"]),
                                BuyNum: parseInt(ws[index]["每单拍几件"]),
                                Img:"",
                                Remark: "",
                                BuyRemark: "",
                                ZiyuanImg:[],
                                Video:"",
                                ChildList:new Array(),
                                MasterId:ws[index]["标识"],
                                PositiveContent:"",
                            });
                        }
                    }
                })
                taskExistDetail({json:JSON.stringify(arr),shopId:this.task.ShopId},(res)=>{
                    this.isLoading=false;
                    this.task.Details=res.Result;
                    this.task.Details.forEach(x=>{
                        var array=new Array();
                        if(this.task.KeyType==2){
                            x.KeyWords="";
                        }
                        if(x.Img){
                            array.push({
                                name:x.Img,
                                response:{
                                    IsSuccess:true,
                                    Message:x.Img,
                                },
                                status:"done",
                                thumbUrl:x.Img,
                                type:"image/jpeg",
                                uid:x.Img,
                            });
                        }
                        this.fileList.push(array);
                    })
                })
                
                } catch (e) {
                    message.error("填写数据错误或模板错误，请核对");
                    this.loadingExl=false;
                    return false;
                }
            };
            fileReader.readAsBinaryString(files[0]);
        },

        importExcel(){
            if(!this.task.ShopId){
                message.error("请先选择好店铺");
                return; 
            }
            this.$refs.uploadExcel.click();
        },
        xiazai(){
          window.open(this.mubanUrl);  
        },
        goodsInfo(){
            var array=new Array();
            this.task.Details.forEach(x=>{
                if(x.Url){
                    array.push(x.Url)
                }
                if(x.ChildList){
                    x.ChildList.forEach(c=>{
                        if(c.Url){
                            array.push(c.Url);
                        }
                    })
                }
            })
            if(array.length>0){
                this.isLoading=true;
                this.fileList=[];
                taskGetGoodsInfo({json:JSON.stringify(array)},(res)=>{
                    if(res.Result.length>0){
                        this.task.Details.forEach(x=>{
                            var info =res.Result.find(v=>v.Url==x.Url)
                            x.Title=info.Title;
                            x.Img=info.Img;
                            x.ShowPrice=info.ShowPrice;
                            var array=new Array();
                            array.push({
                                name:x.Img,
                                response:{
                                    IsSuccess:true,
                                    Message:x.Img,
                                },
                                status:"done",
                                thumbUrl:x.Img,
                                type:"image/jpeg",
                                uid:x.Img,
                            });
                            this.fileList.push(array);
                            if(x.ChildList){
                                x.ChildList.forEach(c=>{
                                    var childInfo =res.Result.find(v=>v.Url==c.Url)
                                    c.Title=childInfo.Title;
                                    c.Img=childInfo.Img;
                                    c.ShowPrice=childInfo.ShowPrice;
                                });
                            }
                        })
                    }else{
                        message.error("没有获取到内容，请检查链接"); 
                    }
                    this.isLoading=false;
                })
            }
        },
        copyRow(index){
            if(this.task.Details.length>0){
                let model=JSON.parse(JSON.stringify(this.task.Details[index]));
                model.Video="";
                model.ZiyuanImg=[];
                model.PositiveContent="";
                model.ChildList.forEach(x=>{
                    x.Video="";
                    x.ZiyuanImg="";
                    x.PositiveContent="";
                })
                this.task.Details.push(model);
                this.fileList.push((JSON.parse(JSON.stringify(this.fileList[index]))));
                this.codeFileList.push((JSON.parse(JSON.stringify(this.codeFileList[index]))));
            }else{
                message.error("第一行没有内容！"); 
            }
        },
        getPicture(record){
            toolGetPicture({link:record.Url},(res)=>{
                if(res.IsSuccess){
                    record.Img= res.Message;
                }else{
                    message.error(res.Message); 
                }
            })
        },
        goPay(){
            if(this.paying){
                return;
            }
            if(!this.datePickerValue){
                message.error("请选择期望完成日期"); 
                return;
            }
            if(this.task.Details.length==0){
                message.error("您没有添加任务商品数据"); 
                return;
            }
            this.paying=true;
            this.task.Details.forEach(x=>{
                let array=[];
                x.ZiyuanImg.forEach(e=>{
                    array.push(e.response.Message);
                })
                x.ZiyuanImg=array;
                x.ChildList.forEach(c=>{
                    if(c.ZiyuanImg&&c.ZiyuanImg.length>0){
                        let childArray=[];
                        c.ZiyuanImg.forEach(e=>{
                            childArray.push(e.response.Message);
                        })
                        c.ZiyuanImg=childArray;
                    }
                })
            });
            this.task.ExpectedOverTime=this.format(new Date(this.datePickerValue),"yyyy-MM-dd 00:00:00");
            taskPreCreate({json:JSON.stringify(this.task)},(res)=>{
                if(res.IsSuccess){
                    this.$router.push({path:'/pay',query:{code:res.Result.Code}});
                }else{
                    message.error(res.Message); 
                }
                this.paying=false;
            })
         },
        changeKeyType(type){
            this.task.KeyType = type;
        },
        setPraise(record){
            this.setRow=record;
            this.praiseVisible=true;
        },
        remove(index){
            this.task.Details.splice(index, 1);
            this.fileList.splice(index, 1);
        },
        handleChange(info,record){
            if(info.file.status=="uploading"){
                this.uploading=true;
            }
            else if(info.file.status=="removed"){
                record.Img="";                
            }
            else{
                if(info.file.response){
                    var res=info.file.response;
                    if(res.IsSuccess){
                        this.uploading=false;
                        record.Img= res.Message;
                    }else{
                        message.error(res.Message);
                    }
                }
            }
        },
        keyWordChange(info,record){
            if(info.file.status=="uploading"){
                this.uploading=true;
            }
            else if(info.file.status=="removed"){
                record.KeyWords="";                
            }
            else{
                if(info.file.response){
                    var res=info.file.response;
                    if(res.IsSuccess){
                        this.uploading=false;
                        record.KeyWords= res.Message;
                        console.log(record.KeyWords);
                    }else{
                        message.error(res.Message);
                    }
                }
            }
        },
        handlePreview(file){
            this.previewImage = file.response.Message;
            this.previewVisible = true;
        },
        addRow(num){
            if(!this.task.ShopId){
                message.error("请先选择好店铺！");
                return; 
            }
            for(var i=0;i<num;i++){
                this.fileList.push(new Array());
                this.codeFileList.push(new Array());
                let row={
                    Title:"",
                    Url:"",
                    ShowPrice:0,
                    Price:0,
                    BuyNum:1,
                    Spec:"",
                    BuyRemark:"",
                    KeyWords:"",
                    Num:1,
                    Video:"",
                    ZiyuanImg:[],
                    Img:"",
                    PositiveContent:"",
                    ChildList:[],
                }
                this.task.Details.push(row);
            }
        },

        filterOption(input, option) {
            return option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        videoChange(info){
            if(info.file.status=="uploading"){
                this.uploading=true;
            }
            else if(info.file.status=="removed"){
                this.setRow.Video="";
            }
            else{
                if(info.file.response){
                    var res=info.file.response;
                    if(res.IsSuccess){
                        this.uploading=false;
                        this.setRow.Video= res.Message;
                    }else{
                        message.error(res.Message);
                    }
                }
            }
        },
        format (date,fmt) {
            let o = {
                "M+": date.getMonth() + 1,         //月份
                "d+": date.getDate(),          //日
                "h+": date.getHours(),          //小时
                "m+": date.getMinutes(),         //分
                "s+": date.getSeconds(),         //秒
                "q+": Math.floor((date.getMonth() + 3) / 3), //季度
                "S": date.getMilliseconds()       //毫秒
            };
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
            }
            for (let k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                }
            }
            return fmt;
        }
    }
}
</script>
<style scoped>
.prase-btn{
    cursor: pointer;
}
.title{
    font-weight:50;font-size:16px;letter-spacing:1px;border-left:3px solid #f082ac;padding-left:10px
}
.shop-sel{
    cursor: pointer;display:inline-block;margin-left:0px;margin-right:20px;margin-bottom: 20px;border:1px solid #ddd;padding-left:10px;padding-right:10px;
    color:#6e6d7a;padding-top: 5px;padding-bottom: 5px;line-height: 25px;

}
.shop-active{
    cursor: pointer;display:inline-block;margin-left:0px;margin-right:20px;margin-bottom: 20px;border:1px solid #f082ac;;padding-left:10px;padding-right:10px;
    color: #f082ac;;background-color: #fef6f9;padding-top: 5px;padding-bottom: 5px; line-height: 25px;
}
.shop-sel:hover{
    color: #f082ac;
    border-color: #f082ac;
}
</style>